<template>
  <v-form @submit.prevent.stop="saveItems">
    <v-card>
      <v-card-title>{{ formName || 'Product configuration' }}</v-card-title>
      <v-card-text>Here you can add integrated storage connections to iAnnotate. If you make no changes then OneDrive and Local Storage will be your default.</v-card-text>
      <v-card-text>
        <v-row
          v-for="(item, itemIndex) of formItems"
          :key="itemIndex"
          :class="{
            'padding-bottom-110': !isMobile,
            'customized-row': !isMobile
          }"
          dense
        >
          <v-col v-if="!isMobile" cols="4" class="row align-content-center">
            <v-subheader><h3 :class="{'read_only': item.read_only}">{{item.name}}</h3></v-subheader>
          </v-col>
          <v-col :cols="isMobile ? 12 : 8"  class="row align-content-center mb-2">
            <v-select
              v-if="item.type === 'dropdowns'"
              :label="isMobile ? item.name : null"
              outlined rounded
              item-text="value"
              item-value="id"
              :items="item.values"
              v-model="item.value"
              @change="onChanged"
              :disabled="item.read_only"
            />

            <v-text-field
              v-if="item.type === 'strings'"
              :label="isMobile ? item.name : null"
              outlined rounded
              v-model="item.value"
              @change="onChanged"
              :disabled="item.read_only"
            />

            <v-switch
              v-if="item.type === 'bools'"
              :label="isMobile ? item.name : null"
              outlined rounded
              v-model="item.value"
              @change="onChanged"
              :disabled="item.read_only"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <br/>
    <v-row>
      <v-col :cols="isMobile ? 12 : 3">
        <v-btn
          block x-large rounded color="primary"
          type="submit"
          :disabled="disabledSaveBtn"
          :loading="loading"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>

  </v-form>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {isMobileMixin} from "@/mixins";
const FIELD_TYPES = ['dropdowns', 'strings', 'bools']

export default {
  name: "iAnnotateConfiguration",
  mixins: [isMobileMixin],
  components: {},
  data() {
    return {
      loading: false,
      FIELD_TYPES,
      formName: null,
      formItems: [],
      hasAChanges: false,
    }
  },
  computed: {
    ...mapState(['profile', 'products']),
    disabledSaveBtn() {
      const disabled = true, enabled = false

      if (this.loading) return disabled
      if (!this.hasAChanges) return disabled
      return enabled
    }
  },
  async mounted() {
    await this.parseData()
  },
  methods: {
    ...mapActions(['getConfig', 'updateConfig']),
    async parseData() {
      if (!this.profile) return
      await this.getConfig(this.profile.product)
      const product = this.profile.product
      if (!product) return
      const {form = {}, selected_fields = {}} = JSON.parse(JSON.stringify(this.$store.state.products[product]))
      this.formName = form.form_name
      this.formItems = []

      for (const field in form) {
        if (!this.FIELD_TYPES.includes(field)) continue
        for (const item of form[field]) {
          const values = item.items.map(i => ({
            id: i.id,
            value: i.value,
            default: i.default
          }))

          let value

          if (field === 'dropdowns') {
            const defaultValue = values.find(v => v.default === true) || values[0]
            const currValueObj = selected_fields[field].find(obj => obj.field_id === item.id) || {}
            const valueObj = values.find(v => v.id === currValueObj.value_id) ||  defaultValue
            value = valueObj ? valueObj.id : ''
          } else {
            const defaultValue = values.find(v => v.default === true) || values[0]
            const currValueObj = selected_fields[field].find(obj => obj.field_id === item.id)
            const valueObj = currValueObj || defaultValue
            value = valueObj ? valueObj.value : ''
          }

          this.formItems.push({
            type: field, id: item.id, read_only: Boolean(item.read_only), name: item.name, values, value,
          })
        }
      }
    },
    async saveItems() {
      if (this.disabledSaveBtn) return
      const data = {}
      for (const item of this.formItems) {
        // console.log('Save item', item)
        const {id, type, value} = item
        data[type] = data[type] || []
        if (type === 'dropdowns') {
          data[type].push({
            "field_id": id, "value_id": value
          })
        } else if (type === 'bools') {
          data[type].push({
            "field_id": id, "value": Boolean(value)
          })
        } else {
          data[type].push({
            "field_id": id, "value": value
          })
        }
      }
      await this.updateConfig(data)
      this.hasAChanges = false
    },
    onChanged() {
      this.hasAChanges = true;
    }
  }
}
</script>

<style scoped lang="scss">
  .public-switch {
    display: flex;
    align-items: center;
    padding: 3px;
    border-radius: 100px;
    width: 44px;
    height: 22px;

    .public-switch-point {
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: #FFFFFF;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
      cursor: pointer;
    }
    
    &.switch-on {
      justify-content: flex-end;
      background-color: #F04E23;
    }
    &.switch-off {
      justify-content: flex-start;
      background-color: #979797;
    }
  }
.customized-row {
  background: rgba(192, 192, 192, 0.16);
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(15, 10, 10, 0.16);
  margin-bottom: 10px;
}

.read_only {
  color: #9d9c9c;
}
</style>